import React, { useState, useEffect } from 'react'
import { useStoreActions, useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import Text from '../../utils/Text'
import media from '../../utils/media'
import CheckboxText from './CheckboxText'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  flex-wrap: wrap;
  /* min-height: 320px; */
  ${media.mobileL`
    max-height: 100%;
    flex-wrap: nowrap;
  `}
`

const Title = styled.div`
  text-align: left;
  margin-bottom: 10px;
  p {
    color: #ffae45;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.84;
  }
`

export default function CheckboxTexts({
  answers,
  rules: { maxAnswers, maxAnswersText },
}) {
  const [{ answerQuestion }] = useStoreActions(state => [state.quiz])
  const [selected, setSelected] = useState([])
  const t = useStoreState(state => state.locale.t)

  function getT(id, value) {
    if (!value.match(/[ap]\d/)) {
      if (id === undefined) {
        console.log(
          '%cTranslation error: id is required in Text Component',
          'color: red',
        )
        return null
      }
      return t(id, {})
    }
    return value
  }

  useEffect(() => {
    if (selected.length === maxAnswers) answerQuestion(selected)
    else answerQuestion(undefined)
  }, [maxAnswers, selected, answerQuestion])

  const handleOnChange = newItem => {
    const index = selected.indexOf(newItem)
    if (index === -1) {
      selected.push(newItem)
    } else {
      selected.splice(index, 1)
    }
    if (selected.length > parseInt(maxAnswers, 10)) {
      selected.splice(index, 1)
    }
    setSelected([...selected])
  }

  return (
    <>
      <Container>
        <Title>
          <Text id={maxAnswersText} />
        </Title>
        {answers.map(answer => {
          return (
            <CheckboxText
              key={answer.title}
              title={answer.title}
              value={getT(answer.title, answer.value)}
              checked={selected.includes(
                getT(answer.title, answer.value),
              )}
              onChange={e => {
                handleOnChange(e.target.value)
              }}
            />
          )
        })}
      </Container>
    </>
  )
}
